import { Context, Dispatch } from "react";
import { createStateHook, createDispatchHook } from ".";

/**
 * Create a hook and return a pair of state and dispatch
 */
export const createContextHook = <S, A>(
  stateContext: Context<S | undefined>,
  dispatchContext: Context<Dispatch<A> | undefined>
) => {
  return (): [S, Dispatch<A>] => [
    createStateHook(stateContext)(),
    createDispatchHook(dispatchContext)(),
  ];
};
